/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingOptionDto } from '../../models/setting-option-dto';

export interface ListReportUrlGrants$Params {}

export function listReportUrlGrants(
  http: HttpClient,
  rootUrl: string,
  params?: ListReportUrlGrants$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<SettingOptionDto>>> {
  const rb = new RequestBuilder(rootUrl, listReportUrlGrants.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SettingOptionDto>>;
    })
  );
}

listReportUrlGrants.PATH = '/admin/reporting/report-url/grants';
